import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pagamento, PaisesService } from 'eddydata-lib';

@Component({
  selector: 'lib-pagamento-reinf',
  templateUrl: './pagamento-reinf.component.html'
})
export class PagamentoReinfComponent implements OnInit {

  @Input() pagamento: Pagamento;
  @Output() callback: EventEmitter<Pagamento> = new EventEmitter();

  imaskConfig = {
    mask: Number,
    scale: 2,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  paises: { codigo: number, nome: string }[] = [];

  constructor(protected paisesService: PaisesService) { }

  ngOnInit(): void {
    this.paises = this.paisesService.listaPaisesReinf();
  }

  salvar() {
    this.callback.emit(this.pagamento);
  }
}
